import type ServiceApi from "../../api";
import {AvmApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {QualityFurnishingsRequest, QualityFurnishingsResponse} from "../payload-types/quality-furnishings";

/**
 * API-Interface für die Ausstattungsqualität nach NHK (POST {@link AvmApi.PATH_QUALITY_FURNISHINGS}).
 */
export class QualityFurnishingsApiInterface extends SimpleApiInterface<QualityFurnishingsResponse> {
    constructor(
        private readonly segment: string,
        private readonly craftsWeights: Record<string, unknown>,
        private readonly signal?: AbortSignal,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildAvmApiUrl([AvmApi.PATH_QUALITY_FURNISHINGS]);
    }

    protected buildPayload(): QualityFurnishingsRequest {
        return {segment: this.segment, ...this.craftsWeights};
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<QualityFurnishingsResponse> {
        return executor.fetchPOST(url, credentials, this.buildPayload(), this.signal);
    }
}
